



































import { Component, Prop, Vue } from 'vue-property-decorator';
import NavbarDark from '@/components/NavbarDark.vue';
import CompraBlanqueamiento from '@/components/CompraBlanqueamiento.vue';
import Footer from '@/components/Footer.vue';

@Component({
  components: {
    NavbarDark,
    CompraBlanqueamiento,
    Footer,
  },
})
export default class KitBlanqueamiento extends Vue {
  public data() {
    return {
      contents: [
        { introText: 'Nuestro kit contiene todo lo que necesitas para conseguir una sonrisa más blanca. Podrás encontrar un tratamiento completo de blanqueamiento dental, incluyendo un acelerador de luz LED portátil y 3 plumas con fórmula de blanqueamiento 100% segura y efectiva, la cual es la misma que utilizan los dentistas en su consultorio. Con el kit de blanqueamiento Toothly te garantizamos dientes más blancos 3 veces más rápido que con otras alternativas, como las tiras blanqueadoras.'},
        { detailTitle: 'Detalles'},
        { detail: '● Blanqueamiento dental de calidad profesional en casa'},
        { detail: '● 3 plumas con 2ml de gel para blanqueamiento dental (peróxido de carbamida al 35%)'},
        { detail: '● Gel de rápida absorción '},
        { detail: '● Refrescante sabor a menta'},
        { detail: '● Acelerador de luz LED de 16 bulbos que funciona conectándose al celular'},
        { detail: '● Compatible con Android y iPhone'},
        { detail: '● Bajo consumo de batería celular'},
        { ingredientTitle: 'Ingredientes'},
        { ingredientText: 'Peróxido de carbamida al 35%, agua, glicerina, propilenglicol, goma xantana, citrato de sodio, mentol, fitato sódico, goma de algarrobo, ácido salicílico, silicato de sodio, xilitol, pirofosfato tetrasódico. Producto aprobado por la FDA y CE.'},
      ],
    };
  }
}
